import { patchState } from '@ngrx/signals';
import { immerReducer } from 'ngrx-immer';
function toFullStateUpdater(updater) {
  return state => {
    const patchedState = updater(state);
    if (patchedState) {
      return {
        ...state,
        ...patchedState
      };
    }
    return;
  };
}
function immerPatchState(state, ...updaters) {
  const immerUpdaters = updaters.map(updater => {
    if (typeof updater === 'function') {
      return immerReducer(toFullStateUpdater(updater));
    }
    return updater;
  });
  patchState(state, ...immerUpdaters);
}

/**
 * Generated bundle index. Do not edit.
 */

export { immerPatchState };
